import { HttpContextToken } from '@angular/common/http'

/**
 * Context token to bypass error toast for specific requests
 * @example In the service, req.context.set(BypassErrorToast, true)
 * @example In the interceptor, if (request.context.get(BypassErrorToast)) return next.handle(request);
 */
export const BypassErrorToast = new HttpContextToken<boolean>(() => false)

/**
 * Context token to bypass error handling for specific requests
 * @example In the service, req.context.set(BypassErrorHandling, true)
 * @example In the interceptor, if (request.context.get(BypassErrorHandling)) return next.handle(request);
 */
export const BypassErrorHandling = new HttpContextToken<boolean>(() => false)
